"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.productCompare.name': 'Comparar Productos',
    'tools.productCompare.description': 'Compara productos de dominios específicos de e-commerce y sitios web',
};
